import React, { useEffect, useState } from "react";
import ExpAnalyStyle from "./expressionanalysis.module.css";

import ExpressionI from "./component/ExpressionI";
import ExpressionII from "./component/ExpressionII";

function ExpressionAnalysis() {

  return (
    <div className={ExpAnalyStyle.ExpAnaly_app}>
      <div className={ExpAnalyStyle.ExpAnaly_Header}>Expression analysis</div>
     <ExpressionI/>
    <ExpressionII/>
    </div>
  );
}

export default ExpressionAnalysis;
